import { z } from 'zod'

import { Account } from '@/business-logic/wallet/domain/wallet/Account'
import { PrivateKey } from '@/business-logic/wallet/domain/wallet/PrivateKey'
import { Wallet } from '@/business-logic/wallet/domain/wallet/Wallet'

export const WalletSchemaV2Schema = z.object({
  privateKeys: z.array(z.string().regex(/^[\dA-Fa-f]{64}$/)),
})

export type WalletSchemaV2 = z.infer<typeof WalletSchemaV2Schema>

/**
 * Maps a V2 wallet to a Wallet domain object.
 */
export function mapDTOToDomain(dto: unknown): Wallet {
  const version2Vault = WalletSchemaV2Schema.parse(dto)

  const accounts = version2Vault.privateKeys.map(privateKeyString =>
    Account.create({
      privateKey: PrivateKey.create({
        privateKeyValue: Buffer.from(privateKeyString, 'hex'),
      }),
    })
  )

  return Wallet.create({ accounts })
}

export function mapDomainToDTO(wallet: Wallet): WalletSchemaV2 {
  const privateKeys = wallet.getAccounts().map(account => {
    const privateKey = account.getPrivateKey()
    return privateKey.getValue().toString('hex')
  })

  return { privateKeys }
}
